import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query, Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import CustomerForm from '~/components/customerForm/customerForm';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import { customerValidationSchema } from '../../validation/customer';

export const getCustomerQuery = gql`
  query customer($id: Int!) {
    customer(id: $id) {
      id
      name
      email
      contactName
      phone
      streetAddress
      streetAddress2
      suburb
      city
      postcode
      country
      birthDate
      fin
      notes
    }
  }
`;

export const updateCustomersMutation = gql`
  mutation updateCustomer(
    $id: Int!
    $name: String!
    $email: String!
    $contactName: String
    $phone: String
    $streetAddress: String
    $streetAddress2: String
    $suburb: String
    $city: String
    $postcode: String
    $country: String
    $birthDate: String
    $fin: String
    $notes: String
  ) {
    updateCustomer(
      id: $id
      name: $name
      email: $email
      contactName: $contactName
      phone: $phone
      streetAddress: $streetAddress
      streetAddress2: $streetAddress2
      suburb: $suburb
      postcode: $postcode
      city: $city
      country: $country
      birthDate: $birthDate
      fin: $fin
      notes: $notes
    ) {
      id
    }
  }
`;

export class CustomerEdit extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Same issue around bad things happening with the Query onCompleted callback
      return false;
    }

    return true;
  }

  render() {
    const { onCompleted, id, history } = this.props;
    return (
      <Query query={getCustomerQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { customer } = data;
          return (
            <div className="content">
              <Mutation mutation={updateCustomersMutation}>
                {(updateCustomer, { error }) => (
                  <Formik
                    initialValues={customer}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={customerValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        await updateCustomer({
                          variables: values
                        });
                        history.push(`/customers/${id}?updated=true`);
                      } catch (err) {
                        console.log(err);
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={CustomerForm}
                  />
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(withApollo(CustomerEdit));



// WEBPACK FOOTER //
// ./src/containers/customerEdit/customerEdit.jsx